var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.9611L5.99998 14.8611L1.69615 16.5265C1.40128 16.6406 1.12821 16.6079 0.876925 16.4284C0.625642 16.2489 0.5 16.0034 0.5 15.6919V2.57654C0.5 2.3791 0.552892 2.20186 0.658675 2.04481C0.764442 1.88776 0.912833 1.77398 1.10385 1.70346L5.99998 0.0380859L12 2.13809L16.3038 0.472711C16.5987 0.358611 16.8717 0.386495 17.123 0.556361C17.3743 0.726228 17.5 0.963728 17.5 1.26886V14.4611C17.5 14.6649 17.4423 14.8438 17.3269 14.9976C17.2115 15.1515 17.0551 15.2637 16.8576 15.3342L12 16.9611ZM11.25 15.1265V3.42651L6.74995 1.85344V13.5534L11.25 15.1265ZM12.75 15.1265L16 14.0496V2.19959L12.75 3.42651V15.1265ZM1.99997 14.7996L5.25 13.5534V1.85344L1.99997 2.94959V14.7996Z",
    fill: "#082C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateIcon);
export default __webpack_public_path__ + "static/media/stateIcon.c1cbad08ba1e9bca1c9f0c1c3fdcd7f3.svg";
export { ForwardRef as ReactComponent };